const myBillsStyle = (theme) => ({
	contentWrapper: {
		width: '100%',
	},
});

export default myBillsStyle;
